import { EnvironmentProviders, importProvidersFrom, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ZopConfirmationService } from '../services/confirmation/confirmation.service';
import { ZopLoadingService } from '../services/loading/loading.service';
import { ZopSplashScreenService } from '../services/splash-screen/splash-screen.service';
import { ZopUtilsService } from '../services/utils/utils.service';

/**
 * Zop provider
 */
export const provideZopUxCore = (): Array<Provider | EnvironmentProviders> => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    {
      // Disable 'theme' sanity check
      provide: MATERIAL_SANITY_CHECKS,
      useValue: {
        doctype: true,
        theme: false,
        version: true,
      },
    },
    {
      // Use the 'fill' appearance on Angular Material form fields by default
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill',
      },
    },

    importProvidersFrom(MatDialogModule),
    provideEnvironmentInitializer(() => inject(ZopConfirmationService)),

    // HTTP client and interceptors are now configured in the main app config
    provideEnvironmentInitializer(() => inject(ZopLoadingService)),
    provideEnvironmentInitializer(() => inject(ZopSplashScreenService)),
    provideEnvironmentInitializer(() => inject(ZopUtilsService)),
  ];

  // Return the providers
  return providers;
};
